import React from "react";
import { useLang } from "@/i18n/LanguageContext";

// Premium segmented control "EN / FR" — no flags.
// variant: "light" (on dark hero) or "dark" (on light surface)
export const LanguageSwitcher = ({ variant = "dark" }) => {
  const { lang, setLang, languages } = useLang();

  const container =
    variant === "light"
      ? "bg-white/12 border border-white/20 backdrop-blur-md"
      : "bg-white border border-[rgba(10,25,47,0.08)] shadow-sm";

  return (
    <div
      className={`inline-flex items-center rounded-full p-0.5 ${container}`}
      data-testid="language-switcher"
      role="group"
      aria-label="Language"
    >
      {languages.map((l) => {
        const active = lang === l.code;
        const activeCls =
          variant === "light" ? "bg-white text-[#0A192F]" : "bg-[#0A192F] text-white";
        const idleCls = variant === "light" ? "text-white/70" : "text-slate-400";
        return (
          <button
            key={l.code}
            onClick={() => setLang(l.code)}
            data-testid={`lang-${l.code}`}
            aria-pressed={active}
            className={`min-w-[34px] rounded-full px-2.5 py-1.5 text-xs font-bold tracking-wide transition-all duration-300 ${
              active ? `${activeCls} shadow-sm` : idleCls
            }`}
          >
            {l.short}
          </button>
        );
      })}
    </div>
  );
};
